import type {AccessTokenService} from '@/domain/interfaces/AccessTokenService';

export class GetAccessTokenUseCase {
  constructor(private readonly repository: AccessTokenService) {}
  execute = () => {
    return this.repository.get();
  };
}
